import { persistReducer } from "redux-persist";
import storage from "redux-persist/lib/storage";

const initialState = {
  show: false,
  title: 'Alert',
  text: '',
  severity: 'success',  // error, warning, info, success
  codename: false,
  vertical: 'top',
  horizontal: 'center', //{ horizontal: 'left' | 'center' | 'right', vertical: 'top' | 'bottom' }
  duration: 7000,
};

export const actionTypes = {
  ShowAlert: "[SHOW_ALER] Action",
  HideAlert: "[HIDE_ALERT] Action",
};

export const reducer = persistReducer(
  { storage, key: "alert" },
  (state = initialState, action) => {

    const { type, payload } = action;

    switch (type) {
      case actionTypes.ShowAlert:
        return {
          show: true,
          title: payload.title ? payload.title : 'Alert',
          text: payload.text,
          severity: payload.severity ? payload.severity : 'success',
          codename: payload.codename || initialState.codename,
          vertical: payload.vertical ? payload.vertical : 'top',
          horizontal: payload.horizontal ? payload.horizontal : 'center',
          duration: payload.duration ? payload.duration : 7000,
        };
      case actionTypes.HideAlert:
        return initialState;
      default:
        return state;
    }
  }
);

export const actions = {
  showAlert: payload => ({ type: actionTypes.ShowAlert, payload: payload }),
  hideAlert: payload => ({ type: actionTypes.HideAlert, payload: payload })
};
